import { KeenSliderInstance } from 'keen-slider/react';
import { MutableRefObject } from 'react';
const thumbnailPlugin = (mainRef: MutableRefObject<KeenSliderInstance | null>, setActiveSlide?: (slide: number) => void) => slider => {
  const removeActive = () => {
    slider.slides.forEach(slide => {
      slide.classList.remove('active');
    });
  };
  const addActive = idx => {
    slider.slides[idx].classList.add('active');
    if (setActiveSlide) setActiveSlide(idx);
  };
  const addClickEvents = () => {
    slider.slides.forEach((slide, idx) => {
      slide.addEventListener('click', () => {
        if (mainRef.current) mainRef.current.moveToIdx(idx, false, {
          duration: 0
        });
      });
    });
  };
  slider.on('created', () => {
    if (!mainRef.current) return;
    addActive(slider.track.details.rel);
    addClickEvents();
    mainRef.current.on('animationStarted', main => {
      removeActive();
      const next = main.animator.targetIdx || 0;
      addActive(main.track.absToRel(next));
      slider.moveToIdx(Math.min(slider.track.details.maxIdx, next));
    });
  });
};
export default thumbnailPlugin;